export default __webpack_public_path__ + "static/colors-555acd15d9f95361affda8ea770e8688.png";